var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMobile)?_c('ColorPickerMobile',_vm._g(_vm._b({},'ColorPickerMobile',_vm.colorPickerProps,false),_vm.colorPickerEmits)):_c('ColorPickerDesktop',_vm._g(_vm._b({},'ColorPickerDesktop',_vm.colorPickerProps,false),_vm.colorPickerEmits))
}
var staticRenderFns = []

export { render, staticRenderFns }